import { memo, useState } from "react";
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Typography from "@mui/material/Typography";
import type { Setup } from "features/setups/types";
import useSetupsActions from "features/setups/useActions";
import { TriggerableDialog } from "ui/molecules/Dialog";
import ActionPanel from "ui/molecules/ActionPanel";
import type { ActionProps } from "./types";

const Delete = ({ row }: ActionProps) => {
    const { deleteSetup } = useSetupsActions();

    const [isDeleting, setDeleting] = useState(false);

    const onDelete = async (setup: Setup<string>) => {
        setDeleting(true);

        const [request] = deleteSetup(setup, {
            shouldNotifyOnSuccess: true
        });

        await request;

        setDeleting(false);
    };


    return (
        <ListItem disablePadding>
            <TriggerableDialog
                TriggerComponent={({ onClick }) => (
                    <ListItemButton
                        component="button"
                        disabled={!row.isDeletable}
                        onClick={onClick}
                    >
                        <ListItemText
                            primary="Delete"
                            sx={{
                                color: 'error.main'
                            }}
                        />
                    </ListItemButton>
                )}
                DialogActionsComponent={({ onClose }) => (
                    <ActionPanel
                        sx={{
                            flexGrow: 1
                        }}
                        isLoading={isDeleting}
                        onSave={() => onDelete(row)
                            .then(() => onClose())}
                        onCancel={onClose}
                        SaveActionProps={{
                            children: 'Delete',
                            color: 'error'
                        }}
                    />
                )}
                ModalProps={{
                    disableCloseOnBackdropClick: true,
                    titleSlot: `Delete setup ${row.identifier}`,

                }}
            >
                <Typography>
                    {`Are you sure you want to delete ${row.identifier} setup?`}
                </Typography>
            </TriggerableDialog>
        </ListItem>
    );
};

export default memo(Delete);